import React, { ReactNode } from 'react'
import { Box, Text } from '@node-space/ui-components'

export interface StepDescriptionProps {
  paragraphs: ReactNode[]
}

export const StepDescription = ({ paragraphs }: StepDescriptionProps) => {
  return (
    !!paragraphs?.length && (
      <Box flexCol paddingT={16} gap={16}>
        {paragraphs?.map((paragraph, index) => (
          <Text key={`step-description-paragraph-${index}`} color="subdued">
            {paragraph}
          </Text>
        ))}
      </Box>
    )
  )
}
